// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// Small time helpers. All Helios timestamps are displayed as 24-hour HH:MM.

/** Current time as a 24-hour "HH:MM" string. */
export function nowHhmm(): string {
  return new Date().toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/**
 * Parse a "HH:MM" string to minutes-since-midnight for chronological sorting.
 * Returns -1 for anything that isn't HH:MM so malformed values sort last.
 */
export function hhmmToMinutes(t: string): number {
  const m = t.trim().match(/^(\d{1,2}):(\d{2})$/);
  if (!m) return -1;
  const hours = Number(m[1]);
  const minutes = Number(m[2]);
  if (hours > 23 || minutes > 59) return -1;
  return hours * 60 + minutes;
}
